import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';


import { ColorInputComponent } from './color-input.component';

@NgModule({
  imports: [
    FormsModule,
    MaterialModule
  ],
  exports: [ColorInputComponent],
  declarations: [ColorInputComponent]
})
export class ColorInputModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/color-input/color-input.module.ts